export function TabAdminDiffusionModelUD() {
  return (
    <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
      <span className="text-xl"></span>
    </div>
  );
}
